export const NoiseOverlay = () => {
  return <div className="grain" aria-hidden="true" data-testid="noise-overlay" />;
};

export default NoiseOverlay;
